module.exports = __webpack_public_path__ + "static/media/CFD_Dashboard_Teaser_compressed.df59c9e1.gif";